import type { ApiCustomView } from '@/types/api'

// Views cached before sharing shipped carry no ownership fields; they were always the caller's own.
export const isOwnedView = (view: ApiCustomView): boolean => view.isOwner !== false

export const canEditView = (view: ApiCustomView): boolean => view.canEdit !== false
